/**
 * FilterBar
 * Search and filter controls for meetings list
 */

import React from 'react';
import { Search, Filter, X } from 'lucide-react';
import { MeetingFilters, MomStatus } from '../../../types';
import { Input } from '../../ui/Input';
import { Button } from '../../ui/Button';
import styles from './FilterBar.module.css';

export interface FilterBarProps {
  filters: MeetingFilters;
  onFiltersChange: (filters: MeetingFilters) => void;
  onClearFilters: () => void;
}

export const FilterBar: React.FC<FilterBarProps> = ({
  filters,
  onFiltersChange,
  onClearFilters,
}) => {
  const hasActiveFilters = 
    filters.search || 
    filters.status || 
    filters.startDate || 
    filters.endDate || 
    filters.organizer;

  return (
    <div className={styles.filterBar}>
      <div className={styles.searchSection}>
        <div className={styles.searchWrapper}>
          <Search size={18} className={styles.searchIcon} />
          <Input
            type="text"
            placeholder="Search meetings..."
            value={filters.search || ''}
            onChange={(e) => onFiltersChange({ ...filters, search: e.target.value })}
            className={styles.searchInput}
          />
        </div>
      </div>

      <div className={styles.filtersSection}>
        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>
            <Filter size={16} />
            Status
          </label>
          <select
            className={styles.select}
            value={filters.status || ''}
            onChange={(e) => 
              onFiltersChange({ 
                ...filters, 
                status: e.target.value as MomStatus || undefined 
              })
            }
          >
            <option value="">All Status</option>
            <option value="none">No MoM</option>
            <option value="generating">Generating</option>
            <option value="draft">Draft</option>
            <option value="sent">Sent</option>
            <option value="approved">Approved</option>
            <option value="jira_created">JIRA Created</option>
          </select>
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>From Date</label>
          <input
            type="date"
            className={styles.dateInput}
            value={filters.startDate || ''}
            onChange={(e) => onFiltersChange({ ...filters, startDate: e.target.value })}
          />
        </div>

        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>To Date</label>
          <input
            type="date"
            className={styles.dateInput}
            value={filters.endDate || ''}
            onChange={(e) => onFiltersChange({ ...filters, endDate: e.target.value })}
          />
        </div>

        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            className={styles.clearButton}
          >
            <X size={16} />
            Clear Filters
          </Button>
        )}
      </div>
    </div>
  );
};

export default FilterBar;
